const CARD_ITEMS = [
  {
    id: 1,
    title: '香蕉视频 · 悬疑烧脑剧场',
    desc: '反转不断的悬疑推理佳作，从国产黑马到日韩口碑之作，考验你的推理能力。',
    tag: '悬疑推理',
    img: 'https://readdy.ai/api/search-image?query=Warm%20golden%20yellow%20and%20deep%20shadow%20abstract%20composition%20with%20mysterious%20atmosphere%2C%20modern%20minimalist%20design%2C%20soft%20lighting%20on%20cream%20background%2C%20suspenseful%20yet%20elegant%20visual%20mood&width=600&height=400&seq=cards-item-01&orientation=landscape',
    alt: '香蕉视频悬疑烧脑剧场',
    stat: '34 部精选',
  },
  {
    id: 2,
    title: '西瓜视频免费 · 暑期亲子',
    desc: '暑假陪娃看片指南，亲子动画、儿童电影、科普短片一次收齐。',
    tag: '亲子时光',
    img: 'https://readdy.ai/api/search-image?query=Bright%20watermelon%20red%20and%20soft%20green%20playful%20abstract%20design%20with%20round%20shapes%2C%20child%20friendly%20warm%20aesthetic%2C%20cheerful%20and%20inviting%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=400&seq=cards-item-02&orientation=landscape',
    alt: '西瓜视频免费暑期亲子',
    stat: '52 部精选',
  },
  {
    id: 3,
    title: '蜜桃视频 · 韩剧热播榜',
    desc: '最新韩剧实时跟进，从浪漫爱情到职场生存，口碑热剧一集不落。',
    tag: '韩剧精选',
    img: 'https://readdy.ai/api/search-image?query=Soft%20peach%20pink%20and%20cream%20abstract%20gradient%20with%20delicate%20flowing%20shapes%2C%20romantic%20and%20dreamy%20atmosphere%2C%20modern%20elegant%20design%2C%20warm%20and%20inviting%20visual&width=600&height=400&seq=cards-item-03&orientation=landscape',
    alt: '蜜桃视频韩剧热播榜',
    stat: '28 部精选',
  },
  {
    id: 4,
    title: '樱花视频 · 新番速递',
    desc: '2026夏季新番完整追番指南，热血、日常、异世界一应俱全。',
    tag: '动漫新番',
    img: 'https://readdy.ai/api/search-image?query=Delicate%20cherry%20blossom%20pink%20and%20white%20abstract%20flowing%20design%20with%20gentle%20curves%2C%20spring%20fresh%20atmosphere%2C%20modern%20anime%20inspired%20aesthetic%2C%20soft%20and%20airy%20visual%20composition&width=600&height=400&seq=cards-item-04&orientation=landscape',
    alt: '樱花视频新番速递',
    stat: '46 部精选',
  },
  {
    id: 5,
    title: '水果视频在线 · 美食探店',
    desc: '全网最火美食纪录片和探店视频合集，从街头小吃到米其林餐厅，下饭必备。',
    tag: '美食天地',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20vibrant%20fruit%20and%20food%20arrangement%20in%20flat%20lay%20style%20on%20light%20wood%20surface%2C%20bright%20natural%20lighting%2C%20fresh%20and%20appetizing%20mood%2C%20modern%20clean%20photography%2C%20warm%20and%20inviting%20colors&width=600&height=400&seq=cards-item-05&orientation=landscape',
    alt: '水果视频在线美食探店',
    stat: '89 部精选',
  },
  {
    id: 6,
    title: '植物视频平台 · 环球风光',
    desc: '不出门看遍世界奇景，从北极冰川到非洲草原，视觉震撼之旅。',
    tag: '旅行风光',
    img: 'https://readdy.ai/api/search-image?query=Lush%20green%20tropical%20landscape%20with%20diverse%20plant%20foliage%20in%20rich%20emerald%20tones%2C%20soft%20morning%20light%2C%20serene%20natural%20atmosphere%2C%20travel%20and%20adventure%20vibe%2C%20modern%20nature%20photography%20aesthetic&width=600&height=400&seq=cards-item-06&orientation=landscape',
    alt: '植物视频平台环球风光',
    stat: '63 部精选',
  },
  {
    id: 7,
    title: '向日葵视频 · 编辑严选',
    desc: '编辑团队每月精选各平台不容错过的优质内容，一人一部私藏推荐。',
    tag: '编辑推荐',
    img: 'https://readdy.ai/api/search-image?query=Warm%20sunflower%20yellow%20and%20cream%20abstract%20composition%20with%20organic%20flowing%20shapes%2C%20elegant%20and%20curated%20aesthetic%2C%20modern%20editorial%20design%2C%20sophisticated%20yet%20approachable%20visual%20mood%2C%20soft%20golden%20lighting&width=600&height=400&seq=cards-item-07&orientation=landscape',
    alt: '向日葵视频编辑严选',
    stat: '12 部精选',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            分类精选
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按主题分类的水果视频在线平台内容导航，精准发现你的偏好
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {CARD_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-secondary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.classList.add('bg-background-200');
                    }
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-secondary-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 mb-1.5 group-hover:text-secondary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-film-line"></i>
                  <span>{item.stat}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}